"use client";

interface FilterTabProps {
  label: string;
  isActive: boolean;
  /** Id of the tabpanel this tab controls. */
  controls: string;
  onSelect: () => void;
}

/** One of the two tabs across the top of the filter modal. */
export default function FilterTab({ label, isActive, controls, onSelect }: FilterTabProps) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={isActive}
      aria-controls={controls}
      onClick={onSelect}
      className={`flex items-center justify-center flex-1 min-w-0 h-12 p-2 text-sm lg:text-base font-medium leading-5 lg:leading-5.5 border-b transition-colors ${
        isActive ? "text-primary border-primary" : "text-gray-1 border-transparent hover:text-dark-1"
      }`}>
      {label}
    </button>
  );
}
